import { render, staticRenderFns } from "./FactoringCommunication.vue?vue&type=template&id=261a6f80&lang=pug&"
import script from "./FactoringCommunication.vue?vue&type=script&lang=js&"
export * from "./FactoringCommunication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports